import ApisService from './index'
import { IUserUpdate, IUserAdd , IUserUpdateRole} from '../interfaces/userInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function register(data: IUserAdd) {
  let bodyData: any = { ...data }
  const phoneNumber = data.phoneNumber || ""

  delete bodyData.phoneNumber
  if (phoneNumber.trim() != "") {
    bodyData.phone = { 
      phoneNumber: phoneNumber, 
      countryAccessCode: '84', }
  }
  if (!bodyData.birthDate) {
    delete bodyData.birthDate
  }
  return ApisService.post('/user/register', bodyData)
}

export async function login(username: string, password: string) {
  return await ApisService.post('/user/login', {
    username,
    password,
  })
}

export function updateProfile(data: Partial<IUserUpdate> & { avatar?: string | null }) {
  let bodyData: any = { ...data }
  const phoneNumber = data.phoneNumber || ""

  delete bodyData.phoneNumber
  delete bodyData.id
  delete bodyData.username
  delete bodyData.userDuAns
  delete bodyData.passwordConfirm
  if (phoneNumber && String(phoneNumber).trim() != "") {
    bodyData.phone = { 
      phoneNumber: phoneNumber, 
      countryAccessCode: '84', }
  }
  if (!bodyData.birthDate) {
    delete bodyData.birthDate
  }
  // Chỉ gửi các field có giá trị (kể cả avatar null để xoá)
  Object.keys(bodyData).forEach((k) => {
    if (bodyData[k] === undefined) delete bodyData[k]
  })
  return ApisService.put('/user/update-user-profile', bodyData)
}


export function updateUser(data: IUserUpdate) {
  let bodyData: any = { ...data }
  const phoneNumber = data.phoneNumber || ""

  delete bodyData.phoneNumber
  if (phoneNumber.trim() != "") {
    bodyData.phone = { 
      phoneNumber: phoneNumber, 
      countryAccessCode: '84', }
  }
  if (!bodyData.birthDate) {
    delete bodyData.birthDate
  }
  return ApisService.put('/user/update-user-profile/' + data.id, bodyData)
}


export function getUserInfo() {
  return ApisService.get('/user/get-user-info')
}

export function getDetailUser(id: string) {
  return ApisService.get('/user/' + id + '/get-user-info')
}

export function getListUser(querySt: any) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/user/filter-users', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}



export function changePassword({
  oldPassword,
  newPassword,
  newPasswordRetype,
}: {
  oldPassword: string
  newPassword: string
  newPasswordRetype: string
}) {
  return ApisService.post('/user/change-password', {
    oldPassword,
    newPassword,
    newPasswordRetype,
  })
}


export function getListRole(query: any) {
  return ApisService.get('/user/get-roles', {
    params: query,
  })
}

export function getListProject() {
  return ApisService.get('/user/get-my-duan')
}

export function changeProject(projectId: number) {
  return ApisService.put('/user/' + projectId + '/doi-duan')
}


export function updateRole(data: IUserUpdateRole) {
  const bodyData = {...data, role: data.role != "" ? data.role : null}
  return ApisService.put('/user/' + data.projectId + '/update-role-duan', bodyData)
}

export function changeBranch(duAnId: number, chiNhanhId: number) {
  return ApisService.put('/user/' + duAnId + '/' + chiNhanhId + '/doi-chinhanh')
}

export function getMyMenu() {
  return ApisService.get('/user/get-my-menu')
}

export function getMyChiNhanh() {
  return ApisService.get('/user/get-my-chi-nhanh')
}

export function getMyDuAn() {
  return ApisService.get('/user/get-my-duan')
}

export function syncUser() {
  return ApisService.post('/user/sync/all-users')
}
